import { StyleSheet } from "react-native";
import { appColors,appFonts,fontSize } from "../../appTheme";

export const VendorStyle = StyleSheet.create({
    mainContainer:{
         flex:1,
         backgroundColor:appColors.lightBackgroundColor
    },
    buttonFont : { 
        fontSize: fontSize?.smallFontSize, 
        fontFamily: appFonts?.bold, 
        color: appColors?.light 
    },
    searchBarView:{
        flexDirection:'row',
        marginHorizontal:7
    },
    iconTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize
    },
    filterTextStyle:{ 
        fontFamily: appFonts.bold, 
        fontSize: fontSize.badgeFontSize 
    },
    filterContainerStyle:{ 
        position: 'absolute', 
        top: -4, 
        right: -4, 
    },
    buttonStyle :{
        borderRadius: 7, 
        backgroundColor: appColors.light,
        borderColor: appColors.primary, 
        borderWidth: 1 
    },
    saveButtonStyle :{
        borderRadius: 10, 
        backgroundColor: appColors.primary, 
        borderWidth: 1, 
        borderColor: appColors.primary,
    },
    nextButton:{ 
        color: appColors.primary, 
        fontFamily: appFonts.bold, 
        fontSize: fontSize.mediumFontSize 
    },
    navigationView:{ 
        flexDirection: 'row', 
        marginVertical: 10, 
        justifyContent: 'flex-end' 
    },
    navigationTitleStyle:{ 
        color: appColors.primary, 
        fontFamily: appFonts.bold, 
        fontSize: fontSize.mediumFontSize 
    },
    titleStyle :{
        color: appColors.primary, 
        fontFamily: appFonts.bold 
    },
    errorStyle :{ 
        color: appColors.red, 
        fontFamily: appFonts.medium, 
        fontSize: fontSize.errorFontSize, 
        marginTop: 2, 
        marginLeft: 0.5
    },
    tabTitleStyle :{ 
        alignSelf: 'center', 
        padding: 10 
    },
    buttonView:{ 
        flexDirection: 'row', 
        alignSelf: 'flex-end', 
        marginRight: 20, 
        marginBottom: 15 
    },
    iconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    flex:{ 
        flex: 1 
    },
    filterSubView:{ 
        flexDirection: 'row', 
        marginVertical: 5, 
        justifyContent: 'flex-end' 
    },
    status:{ 
        fontSize: fontSize.smallFontSize, 
        fontFamily: appFonts.bold, 
        paddingHorizontal: 20 
    },
    buttonText:{
        color: appColors.primary, 
        fontFamily: appFonts.bold, 
        fontSize: fontSize.mediumFontSize 
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginTop: 15
    },
    buttonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold
    },
    filterIconView:{
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5,
        marginVertical:18
    },
    plusIcon:{
        position: "absolute", 
        backgroundColor: appColors.primary, 
        width: 60, 
        height: 60, 
        borderRadius: 32, 
        top: '90%', 
        left: '80%', 
        justifyContent: 'center' 
    },
    resetButtonStyle:{ 
        width: 110, 
        height: 40, 
        borderRadius: 7, 
        backgroundColor: appColors.light, 
        borderWidth: 1, 
        borderColor: appColors.primary 
    },
    applyButtonStyle:{ 
        width: 100, 
        height: 40, 
        borderRadius: 7, 
        backgroundColor: appColors.primary, 
        borderWidth: 1, 
        borderColor: appColors.primary, 
        marginLeft: 10
     },
    resetView:{ 
        flexDirection: 'row', 
        marginVertical: 15, 
        marginHorizontal: 25, 
        justifyContent: "space-between", 
        alignSelf: 'flex-end' 
    },
    dateRange:{
        flexDirection: 'row', 
        justifyContent: 'space-between',
        borderWidth: 1, 
        borderColor: appColors.borderColor, 
        height: 50, 
        borderRadius: 8, 
        marginTop: 10,
        marginHorizontal: 20 
    },
    createdOn:{ 
        fontSize: fontSize.smallFontSize, 
        fontFamily: appFonts.bold, 
        paddingHorizontal: 20 
    },
    filterView:{
        marginVertical: 10, 
        marginHorizontal: 15,
        borderRadius: 16 
    },
    filterText:{ 
        fontSize: fontSize.mediumFontSize, 
        fontFamily: appFonts.bold, 
        color: appColors.lightDark 
    },
    subView:{ 
        flex: 0.7, 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        marginTop: 5 
    },
    contentSection: {
        flexDirection: 'row', flex: 1
    },
    searchInputContainer:{
        backgroundColor:appColors.light
    },
    badgeStyle: {
        width: 18,
        height: 18,
        borderRadius:30,
    },
    textStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
    },
    cardContainer:{ 
        borderRadius: 10, 
        marginBottom: 10, 
        borderWidth: 0,
        borderColor:'transparent',
        elevation:0 
    },
    cardStyle:{
        elevation: 0, 
        borderColor: 'transparent', 
        borderRadius: 16 
    },
    filterViewStyle: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5
    },
    iconView: {
        alignItems: 'flex-end'
    },
    dropLabelStyle:{
        flexWrap: 'wrap',
        color: appColors.lightDark,
        marginLeft: -5,
        fontFamily: appFonts.medium
     },
    badgeView:{
         flexDirection: 'row', 
         justifyContent: 'space-between' 
    },
    badgeText:{ 
        fontFamily: appFonts.bold, 
        fontSize: fontSize.badgeFontSize, 
        color: appColors.light 
    },
    badgeContainer:{ 
        justifyContent: 'center', 
        alignSelf: 'flex-start', 
        marginBottom: 7 
    },
    contentView:{ 
        flexDirection: 'column', 
    },
    activateIcon:{ 
        borderWidth: 1, 
        borderRadius: 11, 
        paddingHorizontal: 10, 
        paddingVertical: 2, 
        borderColor: appColors.light, 
        backgroundColor: appColors.lightBackgroundColor
     },
     closeIcon:{ 
        marginHorizontal: 2, 
        borderWidth: 1, 
        borderRadius: 11, 
        paddingHorizontal: 10, 
        paddingVertical: 2, 
        borderColor: appColors.light, 
        backgroundColor: appColors.lightBackgroundColor
     },
     editIcon:{ 
        borderWidth: 1, 
        borderRadius: 11, 
        paddingHorizontal: 10, 
        paddingVertical: 2, 
        borderColor: appColors.light, 
        backgroundColor: appColors.lightBackgroundColor
     },
     deleteIcon:{ 
        borderWidth: 1, 
        borderRadius: 11, 
        padding: 8, 
        marginHorizontal: 2, 
        borderColor: appColors.light, 
        backgroundColor: appColors.lightBackgroundColor
     },
     tabStyle:{
        marginLeft: 20, 
        marginRight: 8,
        paddingTop: 20, 
        paddingBottom: 15, 
        marginTop: 5, 
        borderTopRightRadius: 26, 
        borderTopLeftRadius: 26
    },
    tabView:{
        marginRight: 20, 
        marginLeft: 8, 
        paddingTop: 20, 
        paddingBottom: 15, 
        marginTop: 5, 
        borderTopRightRadius: 26, 
        borderTopLeftRadius: 26, 
    },
    loader:{
        flex:1,
        justifyContent:'center',
        alignItems:'center'
    },
})